import React, { SVGProps } from 'react';

const SvgCustomSpain = (props: SVGProps<SVGSVGElement>) => (
	<svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 512 512'
        xmlSpace='preserve'
        width='1em'
        height='1em'
        className='svg-icon'
        {...props}>
        <rect
            width="512"
            height="170.67"
            style={{
                fill: '#FF4B55',
                borderTopLeftRadius: '15%',
                borderTopRightRadius: '15%',
            }}
        />
        <rect
            y="170.67"
            width="512"
            height="170.67"
            style={{
                fill: '#FFE15A',
            }}
        />
        <rect
            y="341.34"
            width="512"
            height="170.66"
            style={{
                fill: '#FF4B55',
                borderBottomLeftRadius: '15%',
                borderBottomRightRadius: '15%',
            }}
        />
    </svg>
);

export default SvgCustomSpain;

